import styled from "styled-components";

const StyledExportTableDialog = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export default StyledExportTableDialog;